export default __webpack_public_path__ + "static/media/loading.c84bcaa9.png";